import React from 'react';
import { ConfirmDeletePopup } from 'features/nekst-widgets';
import { useMarketsAdminService, SetupArea } from 'nekst-api';
import useSettingsNavigator from '../../settingsNavigator';

export default function DeleteSetupAreaForm(props: {
  setupArea: SetupArea
}) {
  const marketsService = useMarketsAdminService();

  const settingsNavigator = useSettingsNavigator();

  const isUsed = props.setupArea.versions.some((version) => {
    return version.numberOfUsages > 0;
  });

  const setupArea = props.setupArea;

  let message: string;
  if (isUsed) {
    message = 'The market is used by one or more teams. It\'ll be archived.';
  } else {
    message = `Are you sure you want to delete market "${setupArea.name}"?`
  }

  const marketId = setupArea.market?.id;


  if (marketId) {
    return (
      <ConfirmDeletePopup
        deleteFunc={async () => {
          await marketsService.deleteMarket(marketId);
          settingsNavigator.openAdminMarketsPage();
        }}
        message={message}
        withConfirmationInput
      />
    );
  } else {
    return null;
  }

}
